import React, { useState } from "react";
import { X, CalendarCheck, Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

const empty = { name: "", business: "", email: "", phone: "", service_type: "Website", budget: "", preferred_date: "", details: "" };

const ConsultationModal = ({ open, onClose }) => {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/consultations", form);
      setDone(true);
    } catch (err) { /* noop */ }
    finally { setBusy(false); }
  };

  const close = () => { setDone(false); setForm(empty); onClose(); };

  return (
    <div className="modal-overlay" onClick={close}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={close} aria-label="Close"><X size={20} /></button>
        {done ? (
          <div className="modal-done">
            <CheckCircle2 size={52} color="#3fae4a" />
            <h3>Consultation requested!</h3>
            <p>Thanks {form.name || ""}! We'll reach out to discuss your project and send a quote. You can also call 815-406-9774.</p>
            <button className="btn btn-primary" onClick={close}>Done</button>
          </div>
        ) : (
          <>
            <div className="modal-head">
              <span className="modal-icon"><CalendarCheck size={22} /></span>
              <div>
                <h3>Book a Consultation</h3>
                <p>Tell us about your flyer or website project and we'll send a quote.</p>
              </div>
            </div>
            <form onSubmit={submit} className="modal-form">
              <div className="form-row">
                <div className="field"><label>Your Name</label><input name="name" required value={form.name} onChange={change} placeholder="Jane Trucker" /></div>
                <div className="field"><label>Business Name</label><input name="business" value={form.business} onChange={change} placeholder="Your Trucking LLC" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>Email</label><input type="email" name="email" required value={form.email} onChange={change} placeholder="you@email.com" /></div>
                <div className="field"><label>Phone</label><input name="phone" required value={form.phone} onChange={change} placeholder="(555) 555-5555" /></div>
              </div>
              <div className="form-row">
                <div className="field"><label>I need a</label>
                  <select name="service_type" value={form.service_type} onChange={change}>
                    <option>Website</option>
                    <option>Flyer</option>
                    <option>Both</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="field"><label>Budget (optional)</label><input name="budget" value={form.budget} onChange={change} placeholder="e.g. $500" /></div>
              </div>
              <div className="form-row">
                <div className="field full"><label>Preferred call date/time (optional)</label><input name="preferred_date" value={form.preferred_date} onChange={change} placeholder="e.g. Aug 5, afternoon" /></div>
              </div>
              <div className="form-row">
                <div className="field full"><label>Project details</label><textarea name="details" value={form.details} onChange={change} placeholder="Colors, style, pages, what you want it to say..."></textarea></div>
              </div>
              <button className="btn btn-primary btn-block" disabled={busy}>{busy ? <Loader2 size={16} className="spin" /> : <CalendarCheck size={16} />} Request Consultation &amp; Quote</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ConsultationModal;
